import { FormControl, TextField, MenuItem, InputLabel, Select, RadioGroup, FormControlLabel, Radio, Box, Tabs, Tab, Stack, Button } from '@mui/material'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import TPCheckbox from "../../TemplateProperties/TPCheckbox";
import { authenticationTypeOptions } from '../../../constants/constantList';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';
import { decryptString, encryptString, removeLowerCaseAndUndefined, stringifyJSONAttributes, stringToBooleanConversion } from '../../../utils/utilFunctions';
import TabPanel from '../../TabPanel';
import CommonGrid from '../CommonGrid';
import LightTooltip from '../../../commonComponents/LightTooltip';
import { api } from '../../../redux/api';
import _ from 'lodash';
import { MoreHorizOutlined } from '@mui/icons-material';
import WorkflowSessionModal from '../../ItemProperties/WorkflowSessionModal';
import SmartPasswordField from '../../../commonComponents/SmartPasswordField';

const BridgeGateWebService = ({ connectionDetails, handleBodyContent, direction, screen, disableControl, useConnection, repoPDC, source = "" }) => {
    const shouldEncryptDecryptPassword = String(source || "").toLowerCase() !== "pdc";
    const { t } = useTranslation();
    const { account, baseUrl } = useSelector((state) => state.queryParams);
    const [serviceEndpoint, setServiceEndpoint] = useState('');
    const [serviceName, setServiceName] = useState('');
    const [targetNameSpace, setTargetNameSpace] = useState('');
    const [authentication, setAuthentication] = useState('NONE');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [radioValue, setRadioValue] = useState('INBOUND_VALUE');
    const [syncResponse, setSyncResponse] = useState(false);
    const [syncResponseSOAP, setSyncResponseSOAP] = useState(false);
    const [content, setContent] = useState(null);
    const [currTab, setCurrTab] = useState(0);
    const [operationGridApi, setOperationGridApi] = useState(null);
    const [operationName, setOperationName] = useState('');
    const [soapAction, setSoapAction] = useState('');
    const selectedRow = useRef(null);
    const [selectedRowState, setSelectedRowState] = useState({});
    const [rowData, setRowData] = useState([]);
    const dispatch = useDispatch();
    const [currentTab2, setCurrentTab2] = useState(0);
    const [requestWorkflowGroup, setRequestWorkflowGroup] = useState('');
    const [requestInboundTemplate, setRequestInboundTemplate] = useState('');
    const [responseWorkflowGroup, setResponseWorkflowGroup] = useState('');
    const [responseOutboundTemplate, setResponseOutboundTemplate] = useState('');
    const [responseWorkflowGroupOptions, setResponseWorkflowGroupOptions] = useState([]);
    const [requestWorkflowGroupOptions, setRequestWorkflowGroupOptions] = useState([]);
    const [responseOutboundTemplateOptions, setResponseOutboundTemplateOptions] = useState([]);
    const [requestInboundTemplateOptions, setRequestInboundTemplateOptions] = useState([]);
    const [inboundTemplateList, setInboundTemplateList] = useState([]);
    const [outboundTemplateList, setOutboundTemplateList] = useState([]);
    const [valueLabel, setValueLabel] = useState("");
    const [workflowSessionModal, setWorkflowSessionModal] = useState({
        open: false,
        isFirstTime: false,
    });

    const workflowMappings = {
        [t('LBL_WS_SERVICE')]: {
            stateSetter: setServiceName,
            key: "SERVICE_NAME",
            value: serviceName,
        },
        [t('LBL_WS_TARGET_NAMESPACE')]: {
            stateSetter: setTargetNameSpace,
            key: "TARGET_NAMESPACE",
            value: targetNameSpace,
        },
        [t('LBL_USERNAME')]: {
            stateSetter: setUsername,
            key: "USERNAME",
            value: username,
        },
    };

    const valuesHandler = (value) => {
        if (workflowMappings[valueLabel]) {
            const { stateSetter, key } = workflowMappings[valueLabel];
            stateSetter(value);
            onInputChange(key, value);
        }
    };

    const CustomCellRenderer = (info) => {
        const { value } = info;
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    height: "2rem",
                }}
            >
                <div className='truncated-text' title={value}>
                    {value}
                </div>
                <div className='flex align-center'>
                    <LightTooltip onClick={() => deleteActionHandler(info)}>
                        <span
                            style={{ cursor: "pointer" }}
                            className='DELETE_MUI'
                        ></span>
                    </LightTooltip>
                </div>
            </div>
        );
    };

    const deleteActionHandler = (e) => {
        const data = [];
        e.api.forEachNode((node) => {
            if (e.data.id !== node.data.id) data.push(node.data);
        });
        columnHandler([...data], 0, e.api);
        onInputChange("OPERATIONS", [...data]?.map(e => removeLowerCaseAndUndefined(e)));
        selectedRow.current = { ...data[0] };
        setSelectedRowState({ ...data[0] });
    };

    const columnHandler = (data = [], selectionIndex, gridAPI, fromSubmitHandler, avoidUpdatingSelectedRow) => {
        if (!gridAPI) {
            return;
        }

        const rowData = data?.map((e, i) => {
            return { ...e, id: i, key: e?.WS_OPERATION_NAME || "UNNAMED" };
        });

        gridAPI.setGridOption('rowData', rowData);

        setTimeout(() => {
            gridAPI.forEachNode((node) => {
                if (node?.data?.id === selectionIndex) {
                    node.setSelected(true);
                    if (!avoidUpdatingSelectedRow) {
                        selectedRow.current = node.data;
                        setSelectedRowState({ ...node.data });
                    }
                    // gridAPI.ensureNodeVisible(node);
                }
            });

            if (!rowData?.length) {
                selectedRow.current = {};
                setSelectedRowState({});
            };
        }, 100);
    };

    const customClickHandlerOnAdd = (e) => {

        let colIdArr = []
        e.api.forEachNode((node) => colIdArr.push(node.data.ID));
        const newColumn = {
            key: "UNNAMED",
            WS_OPERATION_NAME: "UNNAMED",
        }

        const data = [];
        const selectedRows = e.api.getSelectedRows();
        e.api.forEachNode((node) => {
            data.push(node.data);
        });
        data.splice(+(selectedRows?.[0]?.id || 0) + 1, 0, {
            ...newColumn,
        });
        selectedRow.current = { ...newColumn };
        setSelectedRowState({ ...newColumn });

        columnHandler(
            [...data],
            data.length && selectedRows?.length ? +selectedRows?.[0]?.id + 1 : 0,
            e.api
        );
        onInputChange("OPERATIONS", [...data]?.map(e => removeLowerCaseAndUndefined(e)));
    }


    const operationGridOptions = {
        columnDefs: [
            {
                addNewControl: true,
                addControlLabel: t("MNU_NEW_ERR_HANDLER"),
                headerName: t("LBL_ERROR_HANDLER_AVAILABLE"),
                field: "key",
                customClickHandlerOnAdd: customClickHandlerOnAdd,
                cellRenderer: (info) => CustomCellRenderer(info),
                editable: false,
                resizable: false,
            },
        ],
        suppressMovableColumns: true,
    };

    const handleOperationRowSelect = (options) => {
        const selectedRows = options.api.getSelectedRows();
        if (selectedRows?.length === 0) return;
        // if (selectedRow?.current?.ID === selectedRows[0]?.ID) return;
        selectedRow.current = { ...selectedRows[0] };
        setSelectedRowState({ ...selectedRows[0] });
        options.api.redrawRows();
    }

    const authenticationTypeDropDownItems = authenticationTypeOptions.map((obj, key) => (
        <MenuItem key={key} value={obj.value}>
            {t(obj.text)}
        </MenuItem>
    ));

    const debouncedContentUpdate = debounce(handleBodyContent, 500);

    // getFontWeights function following the pattern of other adapter types for dynamic field styling
    const getFontWeights = (key) => {
        if (useConnection === 'preDefined' && repoPDC && repoPDC[key] !== connectionDetails?.[key]) {
            return 'bold';
        }
        return 'normal';
    };

    const onInputChange = (name, value, callback) => {
        if(callback) {
            callback();
            return;
        }

        if (screen === 'GET_DATA' || screen === 'SEND_DATA') {
            if (name === "PASSWORD") {
                setContent((prev) => {
                    return { ...prev, [name]: shouldEncryptDecryptPassword ? encryptString(value, process.env.REACT_APP_SECRET_KEY2) : value };
                });
            }else if (name === "SERVICE_NAME") {
                let endpoint = serviceEndpoint;
                if (endpoint) {
                    // Remove last segment after last slash
                    endpoint = endpoint.replace(/\/[^\/]*$/, '');
                    endpoint = `${endpoint}/${value}`;
                    setServiceEndpoint(endpoint);
                }
                setContent((prev) => {
                    return {add : { [name]: value, CONNECTIONSTRING: endpoint } };
                });
            }
            else {
                setContent((prev) => {
                    return { [name]: value };
                });
            }
        }else{
            if (name === "SERVICE_NAME") {

                let endpoint = serviceEndpoint;
                if (endpoint) {
                    // Remove last segment after last slash
                    endpoint = endpoint.replace(/\/[^\/]*$/, '');
                    endpoint = `${endpoint}/${value}`;
                    setServiceEndpoint(endpoint);
                }
                setContent((prev) => {
                    return { ...prev, [name]: value, CONNECTIONSTRING: endpoint };
                });
            }else {
                setContent((prev) => {
                    return { ...prev, [name]: value };
                });
            }
        }
    }

    const handleTabChange = (event, newValue) => {
        setCurrTab(newValue);
    };

    useEffect(() => {
        if(!_.isEqual(connectionDetails, content)) debouncedContentUpdate(content);
    }, [content]);

    useEffect(() => {
        setServiceEndpoint(connectionDetails?.CONNECTIONSTRING || `http://[SERVER_URL]/services/${account}/`)
        setServiceName(connectionDetails?.SERVICE_NAME || '');
        setTargetNameSpace(connectionDetails?.TARGET_NAMESPACE || '');
        setAuthentication(connectionDetails?.AUTHENTICATE || 'NONE');
        setUsername(connectionDetails?.USERNAME || '');
        if(screen === "GET_DATA" || screen === "SEND_DATA") {
			setPassword(
                shouldEncryptDecryptPassword
                    ? (decryptString((connectionDetails?.PASSWORD || ""),process.env.REACT_APP_SECRET_KEY2))
                    : (connectionDetails?.PASSWORD || "")
            );
		}else {
			setPassword(connectionDetails?.PASSWORD || '');
		}
        if (stringToBooleanConversion(connectionDetails?.SOAP_USE_ENVELOPE_AS_RESULT)) {
            setRadioValue('SOAP_ENVELOPE');
        } else if (stringToBooleanConversion(connectionDetails?.WRITE_SOAP_BODY)) {
            setRadioValue('SOAP_BODY');
        } else {
            setRadioValue('INBOUND_VALUE')
        }
        setSyncResponse(stringToBooleanConversion(connectionDetails?.SYNCHRONOUS));
        setSyncResponseSOAP(stringToBooleanConversion(connectionDetails?.SEND_SOURCE_AS_SOAP_BODY));
        setContent({ ...connectionDetails });
        
    }, [connectionDetails]);

    useEffect(() => {
        
        setOperationName(selectedRowState?.WS_OPERATION_NAME || "");
        setSoapAction(selectedRowState?.WS_OP_SOAP_ACTION || "");
        setRequestWorkflowGroup(selectedRowState?.WS_OP_REQ_WF_GROUP || "");
        setRequestInboundTemplate(selectedRowState?.WS_OP_REQ_WF_TEMP || "");
        setResponseWorkflowGroup(selectedRowState?.WS_OP_RES_WF_GROUP || "");
        setResponseOutboundTemplate(selectedRowState?.WS_OP_RES_WF_TEMP || "");
    }, [selectedRowState?.id])

    useEffect(() => {
        if (connectionDetails?.OPERATIONS?.length) {
            columnHandler([...(connectionDetails?.OPERATIONS || [])], 0, operationGridApi);
        }
    }, [connectionDetails?.OPERATIONS, operationGridApi]);

    const changeHandler = useCallback(debounce((name, value) => {
        if (!operationGridApi) return;
        const rowData = [];
        operationGridApi.forEachNode((node) => {
            if (node.data.id === selectedRowState?.id) {
                rowData.push({ ...node.data, [name]: value, ...(name === "WS_OPERATION_NAME" ? {key: value || "UNNAMED"} : {}) });
            } else {
                rowData.push(node.data);
            }
        });
        columnHandler([...rowData], selectedRowState?.id, operationGridApi);
        onInputChange("OPERATIONS", [...rowData]?.map(e => removeLowerCaseAndUndefined(e)));
    }, 500), [operationGridApi, selectedRowState]);

    const fetchWorkflowGroupOptions = useCallback(async () => {
        const response = await dispatch(api.endpoints.getInboundTemplateList.initiate({account}));
        const response2 = await dispatch(api.endpoints.getOutboundTemplateList.initiate({account}));
        if(response?.data?.data?.workflow_groups){
            setInboundTemplateList(response?.data?.data?.workflow_groups);
            setRequestWorkflowGroupOptions(response?.data?.data?.workflow_groups?.map(e => {
                return <MenuItem key={e?.name + Math.random()} value={e?.name}>
                    {e?.name}
                </MenuItem>
            }));
        }
        if(response2?.data?.data?.workflow_groups){
            setOutboundTemplateList(response2?.data?.data?.workflow_groups);
            setResponseWorkflowGroupOptions(response2?.data?.data?.workflow_groups?.map(e => {
                return <MenuItem key={e?.name + Math.random()} value={e?.name}>
                    {e?.name}
                </MenuItem>
            }));
        }
    },[])



    useEffect(() => {
        fetchWorkflowGroupOptions();
    },[])

    useEffect(() => {
        setRequestInboundTemplateOptions(inboundTemplateList?.find(e => e?.name === requestWorkflowGroup)?.inbound_templates?.map(e => {
            return <MenuItem key={e?.name + Math.random()} value={e?.name}>
                {e?.name}
            </MenuItem>
        }));
        setResponseOutboundTemplateOptions(outboundTemplateList?.find(e => e?.name === responseWorkflowGroup)?.outbound_templates?.map(e => {
            return <MenuItem key={e?.name + Math.random()} value={e?.name}>
                {e?.name}
            </MenuItem>
        }));
    }, [requestWorkflowGroup, responseWorkflowGroup])



    return (
        <>
            <Box sx={{ border: 1, borderColor: "divider", borderRadius: 1, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                <Tabs
                    sx={{ backgroundColor: "#fff", borderBottom: 1, borderColor: "divider" }}
                    value={currTab}
                    onChange={handleTabChange}
                >
                    <Tab disabled={disableControl} label={t("TAB_WS_OPERATION")} />
                    {screen === "GET_DATA" && <Tab disabled={disableControl} label={t("LBL_WS_BINDING_OPERATION")} />}
                </Tabs>
                <Box sx={{ p: 2, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                    <TabPanel value={currTab} index={0} style={{ width: '100%', boxSizing: 'border-box' }}>
                        <FormControl size="small" sx={{ mb: 2, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                            <TextField
                                variant="outlined"
                                size="small"
                                label={t("LBL_WS_SERVICE_ENDPOINT_URL")}
                                type="text"
                                value={serviceEndpoint}
                                
                                name={"CONNECTIONSTRING"}
                                autoComplete="off"
                                disabled={disableControl}
                                sx={{ width: '100%', maxWidth: '100%', '& .MuiInputBase-input': { fontWeight: getFontWeights('CONNECTIONSTRING') } }}
                            />
                        </FormControl>
                        <FormControl size="small" sx={{ mb: 2, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    label={t("LBL_WS_SERVICE")}
                                    type="text"
                                    value={serviceName}
                                    onChange={(e) => {
                                        onInputChange(e.target.name, e.target.value);
                                        setServiceName(e.target.value)
                                    }}
                                    name={"SERVICE_NAME"}
                                    autoComplete="off"
                                    disabled={disableControl}
                                    sx={{ flex: 1, '& .MuiInputBase-input': { fontWeight: getFontWeights('SERVICE_NAME') } }}
                                />
                                {screen === "GET_DATA" && <WorkflowSessionModalButton
                                    setWorkflowSessionModal={setWorkflowSessionModal}
                                    label={t("LBL_WS_SERVICE")}
                                    disableControl={disableControl}
                                    setValueLabel={setValueLabel}
                                />}
                            </Box>
                        </FormControl>
                        <FormControl size="small" sx={{ mb: 2, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    label={t("LBL_WS_TARGET_NAMESPACE")}
                                    type="text"
                                    value={targetNameSpace}
                                    onChange={(e) => {
                                        onInputChange(e.target.name, e.target.value);
                                        setTargetNameSpace(e.target.value)
                                    }}
                                    name={"TARGET_NAMESPACE"}
                                    autoComplete="off"
                                    disabled={disableControl}
                                    sx={{ flex: 1, '& .MuiInputBase-input': { fontWeight: getFontWeights('TARGET_NAMESPACE') } }}
                                />
                                {screen === "GET_DATA" && <WorkflowSessionModalButton
                                    setWorkflowSessionModal={setWorkflowSessionModal}
                                    label={t("LBL_WS_TARGET_NAMESPACE")}
                                    disableControl={disableControl}
                                    setValueLabel={setValueLabel}
                                />}
                            </Box>
                        </FormControl>
                        <FormControl variant="outlined" size="small" sx={{ mb: 2, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                            <InputLabel id="authenticationTypeDropdownLabel">
                                {t("LBL_AUTHENTICATION")}
                            </InputLabel>
                            <Select
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            maxHeight: 300,
                                        },
                                    },
                                }}
                                name={"AUTHENTICATE"}
                                labelId="authenticationTypeDropdownLabel"
                                label={t("LBL_AUTHENTICATION")}
                                id="authenticationTypeDropdown"
                                value={authentication || ''}
                                disabled={disableControl}
                                sx={{ width: '100%', maxWidth: '100%', '& .MuiSelect-select': { fontWeight: getFontWeights('AUTHENTICATE') } }}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    onInputChange(e.target.name, value);
                                    setAuthentication(value);
                                    if (value !== 'BASIC') {
                                        onInputChange('USERNAME', '');
                                        setUsername('');
                                        onInputChange('PASSWORD', '');
                                        setPassword('')
                                    }
                                }}
                            >
                                {authenticationTypeDropDownItems}
                            </Select>
                        </FormControl>
                        {
                            authentication === 'BASIC' && <>
                                <FormControl size="small" sx={{ mb: 2, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                                    <Box sx={{ display: 'flex', gap: 1 }}>
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            label={t("LBL_USERNAME")}
                                            type="text"
                                            value={username || ''}
                                            onChange={(e) => {
                                                onInputChange('USERNAME', e.target.value);
                                                setUsername(e.target.value)
                                            }}
                                            name={"USER_NAME"}
                                            autoComplete="off"
                                            disabled={disableControl}
                                            sx={{ flex: 1, '& .MuiInputBase-input': { fontWeight: getFontWeights('USERNAME') } }}
                                        />
                                        {screen === "GET_DATA" && <WorkflowSessionModalButton
                                            setWorkflowSessionModal={setWorkflowSessionModal}
                                            label={t("LBL_USERNAME")}
                                            disableControl={disableControl}
                                            setValueLabel={setValueLabel}
                                        />}
                                    </Box>
                                </FormControl>
                                <Box sx={{ mb: 2, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                                    <SmartPasswordField
                                        variant="outlined"
                                        size="small"
                                        label={t("LBL_WS_PASSWORD")}
                                        type="password"
                                        value={password || ''}
                                        onChange={(e) => {
                                            onInputChange('PASSWORD', e.target.value);
                                            setPassword(e.target.value)
                                        }}
                                        name={"PASS_WORD"}
                                        autoComplete="off"
                                        disabled={disableControl}
                                        sx={{ width: '100%', maxWidth: '100%', '& .MuiInputBase-input': { fontWeight: getFontWeights('PASSWORD') } }}
                                    />
                                </Box>
                            </>
                        }
                        <div className='flex' style={{ marginBottom: 16 }}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name={t('BTN_WS_SOAP_RESULT')}
                                    value={radioValue}
                                    disabled={disableControl}
                                    onChange={(e) => {
                                        if (screen === "GET_DATA") {
                                            onInputChange(null, null, () => {
                                                setContent({ add: {
                                                    SOAP_USE_ENVELOPE_AS_RESULT: e.target.value === 'SOAP_ENVELOPE' ? 'TRUE' : 'FALSE',
                                                    WRITE_SOAP_BODY: e.target.value === 'SOAP_BODY' ? 'TRUE' : 'FALSE',
                                                    SEND_SOURCE_AS_SOAP_BODY: e.target.value === 'INBOUND_VALUE' ? 'TRUE' : 'FALSE',
                                                }})
                                            })
                                            if (e.target.value === 'SOAP_ENVELOPE') {
                                                setRadioValue(e.target.value);
                                            } else if (e.target.value === 'SOAP_BODY') {
                                                setRadioValue(e.target.value);
                                            } else {
                                                setRadioValue(e.target.value);
                                            }
                                        }else {
                                            if (e.target.value === 'SOAP_ENVELOPE') {
                                                setContent((prev) => ({ ...prev, SOAP_USE_ENVELOPE_AS_RESULT: 'TRUE', WRITE_SOAP_BODY: 'FALSE'}));
                                                setRadioValue(e.target.value);
                                            } else if (e.target.value === 'SOAP_BODY') {
                                                setContent((prev) => ({ ...prev, SOAP_USE_ENVELOPE_AS_RESULT: 'FALSE', WRITE_SOAP_BODY: 'TRUE'}));
                                                setRadioValue(e.target.value);
                                            } else {
                                                setContent((prev) => ({ ...prev, SOAP_USE_ENVELOPE_AS_RESULT: 'FALSE', WRITE_SOAP_BODY: 'FALSE'}));
                                                setRadioValue(e.target.value);
                                            }
                                        }
                                    }}
                                    className="flex justify-center"
                                >
                                    <FormControlLabel value="INBOUND_VALUE" control={<Radio disabled={disableControl} />} label={t('BTN_WS_SOAP_INBOUND_VALUE_AS_RESULT')} />
                                    <FormControlLabel value="SOAP_ENVELOPE" control={<Radio disabled={disableControl} />} label={t('BTN_WS_SOAP_ENVELOPE_AS_RESULT')} />
                                    <FormControlLabel value="SOAP_BODY" control={<Radio disabled={disableControl} />} label={t('BTN_WS_SOAP_BODY_AS_RESULT_RADIO')} />
                                </RadioGroup>
                            </FormControl>
                        </div>
                        <Box sx={{ mb: 2 }}>
                            <TPCheckbox
                                label={t("BTN_SEND_SYNC_RESPONSE")}
                                checked={syncResponse}
                                disabled={disableControl}
                                handleCheck={(checked) => {
                                    const syncValue = stringifyJSONAttributes(checked);
                                    
                                    onInputChange(null, null, () => {
                                        const updateData = {
                                            SYNCHRONOUS: syncValue,
                                        };
                                        
                                        // Handle SEND_SOURCE_AS_SOAP_BODY when unchecked and it's currently TRUE
                                        if (!checked && connectionDetails?.SEND_SOURCE_AS_SOAP_BODY === 'TRUE') {
                                            updateData.SEND_SOURCE_AS_SOAP_BODY = 'FALSE';
                                        }
                                        
                                        if (screen === "GET_DATA") setContent({ add: updateData })
                                        else setContent((prev) => ({ ...prev, SYNCHRONOUS: syncValue })); // Update content state
                                    });
                                    
                                    setSyncResponse(checked);
                                    if (!checked) {
                                        setSyncResponseSOAP(false);
                                    }
                                }}
                            />
                        </Box>
                        {syncResponse && <Box sx={{ mb: 2 }}>
                            <TPCheckbox
                                label={t("BTN_WS_SEND_SYNC_AS_SOAP_BODY")}
                                checked={syncResponseSOAP}
                                disabled={!syncResponse || disableControl}
                                handleCheck={(checked) => {
                                    onInputChange('SEND_SOURCE_AS_SOAP_BODY', stringifyJSONAttributes(checked));
                                    setSyncResponseSOAP(checked);
                                }}
                            />
                        </Box>}
                    </TabPanel>
                    <TabPanel value={currTab} index={1} style={{ width: '100%', boxSizing: 'border-box' }}>
                        
                            <CommonGrid
                                gridOptions={operationGridOptions}
                                rowData={rowData}
                                getGridAPI={(e, gridApi) => setOperationGridApi(gridApi.api)}
                                containerStyle={{ height: '200px'}}
                                gridResizable={true}
                                gridProps={{
                                    rowSelection: 'single',
                                    onSelectionChanged: handleOperationRowSelect,
                                }}
                            />
                            <Stack  spacing={2} sx={{ mt: 2 }}>
                                <FormControl size="small" sx={{ mb: 2, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                                    <TextField
                                        disabled={Object.keys(selectedRowState || {}).length === 0}
                                        variant="outlined"
                                        size="small"
                                        label={t("LBL_WS_OPERATION_NAME")}
                                        type="text"
                                        value={operationName}
                                        onChange={(e) => {
                                            changeHandler(e.target.name, e.target.value);
                                            setOperationName(e.target.value)
                                        }}
                                        name={"WS_OPERATION_NAME"}
                                        autoComplete="off"
                                        
                                        sx={{ width: '100%', maxWidth: '100%', '& .MuiInputBase-input': { fontWeight: getFontWeights('CONNECTIONSTRING') } }}
                                    />
                                </FormControl>
                                <FormControl size="small" sx={{ mb: 2, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                                    <TextField
                                        disabled={Object.keys(selectedRowState || {}).length === 0}
                                        variant="outlined"
                                        size="small"
                                        label={t("LBL_WS_SOAP_ACTION")}
                                        type="text"
                                        value={soapAction}
                                        onChange={(e) => {
                                            changeHandler(e.target.name, e.target.value);
                                            setSoapAction(e.target.value)
                                        }}
                                        name={"WS_OP_SOAP_ACTION"}
                                        autoComplete="off"
                                        
                                        sx={{ width: '100%', maxWidth: '100%', '& .MuiInputBase-input': { fontWeight: getFontWeights('CONNECTIONSTRING') } }}
                                    />
                                </FormControl>
                            <Box sx={{ border: 1, borderColor: "divider", borderRadius: 1, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                                <Tabs
                                    
                                    value={currentTab2}
                                    onChange={(e, newValue) => setCurrentTab2(newValue)}
                                    aria-label="request-response-tabs"
                                    sx={{ backgroundColor: "#fff", borderBottom: 1, borderColor: "divider", mb: 2 }}
                                >
                                    <Tab disabled={Object.keys(selectedRowState || {}).length === 0} label={t("TAB_WSOPERATION_REQUEST_VALUES")} sx={{ minHeight: '32px', textTransform: 'none' }} />
                                    <Tab disabled={Object.keys(selectedRowState || {}).length === 0} label={t("TAB_WSOPERATION_RESPONSE_VALUES")} sx={{ minHeight: '32px', textTransform: 'none' }} />
                                </Tabs>
                                {currentTab2 === 0 && (
                                    <Box sx={{ p: 2, boxSizing: 'border-box' }}>
                                        <FormControl disabled={Object.keys(selectedRowState || {}).length === 0} size="small" sx={{ mb: 2, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                                            <InputLabel id="workflow-group-label-request">{t("LBL_WF_GROUP") || "Workflow Group:"}</InputLabel>
                                            <Select
                                                disabled={Object.keys(selectedRowState || {}).length === 0}
                                                labelId="workflow-group-label-request"
                                                id="workflow-group-select-request"
                                                value={requestWorkflowGroup || ""}
                                                label={t("LBL_WF_GROUP")}
                                                onChange={(e) => {
                                                    setRequestWorkflowGroup(e.target.value);
                                                    changeHandler('WS_OP_REQ_WF_GROUP', e.target.value);
                                                }}
                                                MenuProps={{
                                                    PaperProps: {
                                                      sx: {
                                                        maxHeight: "200px",
                                                        "&::-webkit-scrollbar": {
                                                          width: "8px",
                                                        },
                                                        "&::-webkit-scrollbar-thumb": {
                                                          backgroundColor: "#888",
                                                          borderRadius: "4px",
                                                        },
                                                        "&::-webkit-scrollbar-thumb:hover": {
                                                          backgroundColor: "#555",
                                                        },
                                                      },
                                                    },
                                                  }}
                                            >
                                                {requestWorkflowGroupOptions}
                                            </Select>
                                        </FormControl>
                                        <FormControl disabled={Object.keys(selectedRowState || {}).length === 0} size="small" sx={{ mb: 2, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                                            <InputLabel id="inbound-template-label">{t("INBOUND_TEMPLATE_") || "Inbound Template:"}</InputLabel>
                                            <Select
                                                disabled={Object.keys(selectedRowState || {}).length === 0}
                                                labelId="inbound-template-label"
                                                id="inbound-template-select"
                                                value={requestInboundTemplate || ""}
                                                label={t("INBOUND_TEMPLATE_")}
                                                onChange={(e) => {
                                                    setRequestInboundTemplate(e.target.value);
                                                    changeHandler('WS_OP_REQ_WF_TEMP', e.target.value);
                                                }}
                                                MenuProps={{
                                                    PaperProps: {
                                                      sx: {
                                                        maxHeight: "200px",
                                                        "&::-webkit-scrollbar": {
                                                          width: "8px",
                                                        },
                                                        "&::-webkit-scrollbar-thumb": {
                                                          backgroundColor: "#888",
                                                          borderRadius: "4px",
                                                        },
                                                        "&::-webkit-scrollbar-thumb:hover": {
                                                          backgroundColor: "#555",
                                                        },
                                                      },
                                                    },
                                                  }}
                                            >
                                                {requestInboundTemplateOptions}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                )}
                                {currentTab2 === 1 && (
                                    <Box sx={{ p: 2, boxSizing: 'border-box' }}>
                                        <FormControl size="small" sx={{ mb: 2, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                                            <InputLabel id="workflow-group-label">{t("LBL_WF_GROUP") || "Workflow Group:"}</InputLabel>
                                            <Select
                                                disabled={Object.keys(selectedRowState || {}).length === 0}
                                                labelId="workflow-group-label"
                                                id="workflow-group-select"
                                                value={responseWorkflowGroup || ""}
                                                label={t("LBL_WF_GROUP")}
                                                onChange={(e) =>{ 
                                                    setResponseWorkflowGroup(e.target.value);
                                                    changeHandler('WS_OP_RES_WF_GROUP', e.target.value);
                                                }}
                                                MenuProps={{
                                                    PaperProps: {
                                                      sx: {
                                                        maxHeight: "200px",
                                                        "&::-webkit-scrollbar": {
                                                          width: "8px",
                                                        },
                                                        "&::-webkit-scrollbar-thumb": {
                                                          backgroundColor: "#888",
                                                          borderRadius: "4px",
                                                        },
                                                        "&::-webkit-scrollbar-thumb:hover": {
                                                          backgroundColor: "#555",
                                                        },
                                                      },
                                                    },
                                                  }}
                                            >
                                                {responseWorkflowGroupOptions}
                                            </Select>
                                        </FormControl>
                                        <FormControl size="small" sx={{ mb: 2, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                                            <InputLabel id="outbound-template-label">{t("LBL_OUT_TEM.") || "Outbound Template:"}</InputLabel>
                                            <Select
                                                disabled={Object.keys(selectedRowState || {}).length === 0}
                                                labelId="outbound-template-label"
                                                id="outbound-template-select"
                                                value={responseOutboundTemplate || ""}
                                                label={t("LBL_OUT_TEM.")}
                                                onChange={(e) => {
                                                    setResponseOutboundTemplate(e.target.value);
                                                    changeHandler('WS_OP_RES_WF_TEMP', e.target.value);
                                                }}
                                                MenuProps={{
                                                    PaperProps: {
                                                      sx: {
                                                        maxHeight: "200px",
                                                        "&::-webkit-scrollbar": {
                                                          width: "8px",
                                                        },
                                                        "&::-webkit-scrollbar-thumb": {
                                                          backgroundColor: "#888",
                                                          borderRadius: "4px",
                                                        },
                                                        "&::-webkit-scrollbar-thumb:hover": {
                                                          backgroundColor: "#555",
                                                        },
                                                      },
                                                    },
                                                  }}
                                            >
                                                {responseOutboundTemplateOptions}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                )}
                            </Box>
                            </Stack>
                        
                    </TabPanel>
                </Box>
            </Box>
            <WorkflowSessionModal
            valueLabel={valueLabel}
            showAccountData={true}
            showCallingWorkflow={true}
            showSystemData={true}
            showWorkflowSession={true}
            showDateAndTime={true}
            openModal={workflowSessionModal}
            setModalOpen={setWorkflowSessionModal}
            handleClose={() =>
                setWorkflowSessionModal({ open: false, isFirstTime: false })
            }
            initialValue={workflowMappings[valueLabel]?.value}
            valuesHandler={(value) => {
                valuesHandler(value);
            }}
        />
        </>
        
   
    )
}

export default BridgeGateWebService

const WorkflowSessionModalButton = ({setWorkflowSessionModal, label, disableControl, setValueLabel}) => {
    return (
        <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
                setValueLabel(label);
                setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
        </Button>
    );
};